import React from 'react';
import './Footer.css'; // Assurez-vous d'avoir un fichier CSS pour le style


const Footer = () => {
    return (
        <footer className="footer">
            <div className="container section">
                <div className="footer-row">
                    <div className='footer-col'>
                        <h3>Our Softwares</h3>
                        <ul>
                            <li><a href="https://ytcopycat.com" target="_blank" rel="noopener noreferrer">YT Copycat</a></li>
                            <li><a href="https://echonote.xyz" target="_blank" rel="noopener noreferrer">Echonote</a></li>
                        </ul>
                    </div>
                    <div className='footer-col'>
                        <h3>Tools</h3>
                        <ul>
                            <li><a href="/tools" target="_blank" rel="noopener noreferrer">All tools</a></li>
                            <li><a href="/tools/paraphrase" target="_blank" rel="noopener noreferrer">Paraphrasing</a></li>
                            <li><a href="/tools/expand" target="_blank" rel="noopener noreferrer">Content Expansion</a></li>
                            <li><a href="/tools/shorten" target="_blank" rel="noopener noreferrer">Text Shortener</a></li>
                            <li><a href="/tools/style" target="_blank" rel="noopener noreferrer">Style Matcher</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h3>About</h3>
                        <ul>
                            <li><a href="/legal" target="_blank" rel="noopener noreferrer">Term of use</a></li>
                            <li><a href="/legal" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div className="footer-contact">
                        <img src="/logo_light.webp" alt="Logo" className="footer-logo" />
                        <p>Contact us at <a href="mailto:contact@bookwitch.io">contact@bookwitch.io</a></p>
                    </div>
                </div>
                <hr />
                <div className="footer-bottom">
                    <p>Copyright © 2025 Book Witch</p>
                </div>

            </div>
        </footer>
    );
};

export default Footer; 